export class PanelCloserViewModel
{
    opened: boolean = false;

    surveyId: number | null = null;

    show(surveyId: number)
    {
        this.surveyId = surveyId;

        this.opened = true;
    }

    close()
    {
        this.opened = false;

        this.surveyId = null;
    }
}
